import { Page } from '@/core/architecture'

import { QRCodeGetGachaTicketTemplate } from './template'
import { useViewModel } from './viewModel'

export const QRCodeGetGachaTicket: Page = () => {
  const { state, actions } = useViewModel()

  return <QRCodeGetGachaTicketTemplate state={state} {...actions} />
}
